<template>
  <component
    :is="dialogView ? 'v-dialog' : 'div'"
    v-model="localDialogView"
    max-width="300"
  >
    <v-card
      v-if="'accountId' in profileUser"
      height="100%"
      class="justify-center cursor-pointer"
      @click.native="!dialogView ? subDialogView = true : null"
    >
      <v-card-title class="justify-center py-2 profile-image-container">
        <div
          :style="`background-image: url('${profileUser.photoURL || noAvatarSrc}')`"
          class="profile-image-background"
        />
        <v-avatar
          size="120"
          class="profile-image-avatar"
        >
          <img
            :src="profileUser.photoURL || noAvatarSrc"
            :alt="profileUser.name + ' profile image'"
            class="profile-image"
          >
        </v-avatar>
        <v-btn
          v-show="canEdit && dialogView"
          absolute
          right
          bottom
          fab
          small
          color="primary"
          class="mt-4"
          @click.stop="loadEditProfile(profileUser['.key'])"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-title
        class="text-center justify-center pos-rel pb-0"
        :class="{'pt-2': !localShowDetails}"
      >
        <div style="max-width: 100%;">
          <div class="subtitle-1">
            {{ profileUser.name }}
          </div>
          <div v-show="localShowDetails">
            <div
              v-show="profileUser.accountType !== 'individual'"
              class="grey--text caption text-truncate px-2"
              style="margin: 0 auto;"
            >
              {{ profileUser.accountShortName }} | {{ _.startCase(profileUser.accountType) }}<!-- TODO MVP {{ profileUser.isAdmin ? ' | (Admin)' : '' }}{{ profileUser.isAccountAdmin ? ' | (Account&nbsp;Admin)' : '' }} -->
            </div>
            <div
              v-show="profileUser.accountType === 'lawyer'"
              class="caption"
            >
              <span
                v-show="profileUser.areas"
                class="grey--text"
              >
                {{ Object.keys(profileUser.areas || {}).sort().join(', ') }}
              </span><br>
              <a
                href="tel:1300 233 566"
                @click.stop="()=>{}"
              >
                1300 233 566
              </a>
            </div>
          </div>
        </div>
      </v-card-title>
      <v-card-text
        class="display-flex justify-center pt-0 caption"
        :class="{'pb-0': !localShowBio || dialogView}"
      >
        <!--       <div v-show="showBio" class="caption text-left" style="max-width: 300px;">
        <p class="mb-0 mt-2" v-html="profileUser.bio" />
      </div> -->
        <div
          v-show="profileUser.accountType !== 'individual' && localShowBio"
          style="max-width: 300px;"
          class="pos-rel"
        >
          <div :style="'overflow:hidden; height: ' + (dialogView || !localShowBioPartial ? 'auto;' : '62px;')">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p
              class="mb-0 mt-2 white-space-pre-wrap"
            >
              {{ profileUser.bio }}
            </p>
          </div>
          <div
            v-show="!dialogView"
            style="position: absolute; right: 0; bottom:0; background: white;"
            class="pl-2"
          >
            <a
              class="primary--text"
              @click.prevent="localDialogView = true"
            >
              {{ localShowBioPartial ? '...more' : '' }}
            </a>
          </div>
        </div>
      </v-card-text>

      <v-card-actions v-show="dialogView">
        <v-spacer />
        <v-btn
          color="primary"
          small
          @click.stop="localDialogView = false; $emit('close')"
        >
          Close
        </v-btn>
      </v-card-actions>
      <v-card-actions
        v-if="$slots.default"
        class="justify-center"
      >
        <slot />
      </v-card-actions>

      <profile-card
        v-if="subDialogView"
        :profile-user="profileUser"
        :show-bio="true"
        :show-bio-partial="false"
        :dialog-view="subDialogView"
        @close="subDialogView = false"
      />

      <component
        :is="'EditProfile'"
        v-if="editProfileLoaded"
        :show-dialog="editProfileLoaded"
        :uid="selectedUid"
        @close="editProfileLoaded = false; localDialogView = false;"
      />
    </v-card>
  </component>
</template>

<script>

import ProfileCard from './ProfileCard'
import startCase from 'lodash/startCase'
const _ = { startCase }
const EditProfile = () => import('./EditProfile')

export default {
  name: 'ProfileCard',
  components: { ProfileCard, EditProfile },
  props: {
    profileUser: { type: Object, default: () => ({}) },
    showBio: { type: Boolean, default: false },
    showBioPartial: { type: Boolean, default: false },
    showDetails: { type: Boolean, default: true },
    dialogView: { type: Boolean, default: false }
  },
  data: function () {
    return {
      localShowBio: this.showBio,
      localShowBioPartial: this.showBioPartial,
      localShowDetails: this.showDetails,
      localDialogView: this.dialogView,
      subDialogView: false,
      editProfileLoaded: false,
      selectedUid: ''
    }
  },
  computed: {
    canEdit() {
      const canEdit =
        (this.user.uid === this.profileUser['.key'] || this.user.uid === this.profileUser.accountId) ||
        this.isAdmin ||
        (this.isAccountAdmin && this.claims.accountId === this.profileUser.accountId)

      return canEdit
    }
  },
  watch: {
    localDialogView: function (newVal, oldVal) {
      this.$emit('close')
    }
  },
  beforeCreate() {
    this.noAvatarSrc = '/img/noavatar.jpg'
    this._ = _

    this.mapStates(['user', 'appUser', 'claims'])
    this.mapGetters(['isAdmin', 'isAccountAdmin'])
  },
  methods: {
    loadEditProfile(uid) {
      this.selectedUid = uid
      this.editProfileLoaded = true
    }
  }
}
</script>

<style>

.profile-image-container {
   z-index: 1;
   height: 140px;
   width:100%;
   position: relative;
}

.profile-image-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-position: 50% 50%;
  opacity: 0.33;
  z-index: -1;
}

.profile-image-avatar {
  overflow: hidden;
}

.profile-image {
  transform-origin: 50% 20%;
  transform: scale(1.2);
}

</style>
